import React from 'react';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";
import { WithTranslation, withTranslation, Trans } from 'react-i18next';

import { tabStyle } from './TabStyles';
import { Grid, Button, IconButton, Fab } from '@material-ui/core';

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';

import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

import "./style.css"
import { connect } from 'react-redux';
import { AppState, IPageState } from 'appredux';

export type Zakladka = {
    value: number, 
    panelOpis: string
}

interface ZakladkiProps {
    page: IPageState,
    windowWidth: number,
    menuItems: Zakladka[],
    panel: number,
    setPanel: (panel: number, secondary: number) => void,
    marginTop?: string,
    marginBottom?: string,
    fontSize?: string,
}



class Zakladki extends React.Component<ZakladkiProps & WithStyles<typeof styles> & WithTranslation> {

  setPanel = (p: number) => {
    let panel = this.props.panel
    setTimeout(() => {
      if (panel + p > 8) {
        this.props.setPanel(0, 0)
      } else if (panel + p < 0) {
        this.props.setPanel(6, 0)
      } else {
        this.props.setPanel( Math.floor( (panel + p) /3) *3, 0) //panel + p
      }
    }, 1000);
  }

    render() {
        const { classes } = this.props;

        let marginTop = this.props.marginTop? this.props.marginTop : '20px'
        let marginBottom = this.props.marginBottom? this.props.marginBottom : '20px'
        let fontSize = this.props.fontSize? this.props.fontSize : '18px'

        let menuItems = this.props.menuItems
        let menuItems1 = menuItems.slice(0,2) //3
        if(this.props.page.tablet){menuItems1 = menuItems.slice(0,2)}
        let menuItems2 = menuItems.slice(3,6)
        let menuItems3 = menuItems.slice(6,8) //8

        let selectedItem = Math.floor( (this.props.panel) /3)
        

        return (
           <Grid container direction="row" alignItems='center' style={{ margin: `${marginTop} -30px ${marginBottom}`, width: "calc(100% + 60px)" }}>

                 {/* {menuItems.map((item: Zakladka, index: number) => {
                    return (
                        <Grid key={item.value} item style={{ width: this.props.windowWidth <= 100 ? "100%" : `calc((100% )/${menuItems.length})` }}>
                            <Button
                                style={{ width: this.props.windowWidth < 100 || index === menuItems.length - 1 ? "calc(100% )" : "calc(100% + -6px )", padding: "14px 0px", whiteSpace: "pre", fontSize: fontSize }}
                                className={`${this.props.panel === item.value ? classes.inputChosen : classes.input} ${classes.border} ${this.props.panel === item.value ? classes.inputText : classes.inputAlt}`}
                                variant="outlined" color="primary"
                                onClick={() => this.props.setPanel(item.value)}
                            >
                                {item.panelOpis}
                            </Button>
                        </Grid>
                    )
                })}   */}
                
            

            <Carousel
              //statusFormatter={(current, total) => `Current slide: ${current} / Total: ${total}`}
              statusFormatter={(current, total) => ``}
              infiniteLoop
              showIndicators={false}
              transitionTime={1000}
              showThumbs={false}
              selectedItem={selectedItem}
              
              renderArrowPrev={!this.props.page.tablet ? (onClickHandler, hasPrev, label) =>
                hasPrev && (
                  <IconButton onClick={() => {onClickHandler(); this.setPanel(-3)}} className={classes.fab} style={{ left: 4 }} size="medium" aria-label="back">
                    <ArrowBackIosNewIcon style={{ width: "28px", height: "28px", marginLeft: "-2px" }} />
                  </IconButton>
                )
              : () => {}}
              renderArrowNext={ !this.props.page.tablet ? (onClickHandler, hasNext, label) =>
                hasNext && (
                  <IconButton onClick={() => {onClickHandler(); this.setPanel(3)}} className={classes.fab} style={{ right: 4 }} size="medium" aria-label="back">
                    <ArrowForwardIosIcon style={{ width: "28px", height: "28px", marginRight: "-2px" }} />
                  </IconButton>
                )
              : () => {}}
            
            >

              <div className={classes.div}>
               {menuItems1.map((item: Zakladka, index: number) => {
                    return (
                        <Grid key={item.value} item style={{ width: this.props.windowWidth <= 100 ? "100%" : `calc((100% )/${menuItems1.length})` }}>
                            <Button
                                style={{ width: this.props.windowWidth < 100 ? "calc(100% )" : "calc(100% + -3px )", padding: "14px 0px", whiteSpace: "pre", fontSize: fontSize }}
                                className={`${this.props.panel === item.value ? classes.inputChosen : classes.input} ${classes.border} ${this.props.panel === item.value ? classes.inputText : classes.inputAlt}`}
                                variant="outlined" color="primary"
                                onClick={() => this.props.setPanel(item.value, index === 1 ? 1 : 0)}
                            >
                                {item.panelOpis}
                            </Button>
                        </Grid>
                    )
                })}  
               
              </div> 
              
              <div className={classes.div}>
               {menuItems2.map((item: Zakladka, index: number) => {
                    return (
                        <Grid key={item.value} item style={{ width: this.props.windowWidth <= 100 ? "100%" : `calc((100% )/${menuItems2.length})` }}>
                            <Button
                                style={{ width: this.props.windowWidth < 100 ? "calc(100% )" : "calc(100% + -3px )", padding: "14px 0px", whiteSpace: "pre", fontSize: fontSize }}
                                className={`${this.props.panel === item.value ? classes.inputChosen : classes.input} ${classes.border} ${this.props.panel === item.value ? classes.inputText : classes.inputAlt}`}
                                variant="outlined" color="primary"
                                onClick={() => this.props.setPanel(item.value, 0)}
                            >
                                {item.panelOpis}
                            </Button>
                        </Grid>
                    )
                })}  
               
              </div>
              
              <div className={classes.div}>
               {menuItems3.map((item: Zakladka, index: number) => {
                    return (
                        <Grid key={item.value} item style={{ width: this.props.windowWidth <= 100 ? "100%" : `calc((100% )/${menuItems3.length})` }}>
                            <Button
                                style={{ width: this.props.windowWidth < 100 ? "calc(100% )" : "calc(100% + -3px )", padding: "14px 0px", whiteSpace: "pre", fontSize: fontSize }}
                                className={`${this.props.panel === item.value ? classes.inputChosen : classes.input} ${classes.border} ${this.props.panel === item.value ? classes.inputText : classes.inputAlt}`}
                                variant="outlined" color="primary"
                                onClick={() => this.props.setPanel(item.value, 0)}
                            >
                                {item.panelOpis}
                            </Button>
                        </Grid>
                    )
                })}  
               
              </div>
             
            </Carousel>

            {/* <IconButton onClick={onClickHandler} style={{ padding: '4px', ...arrowStyles, left: 15 }}>
              <ChevronLeftIcon style={{ width: "40px", height: "40px" }} fontSize="small" />
            </IconButton> */}




           </Grid>
        );
    }
}

const styles = (theme: Theme) => ({
    input: {
        fontSize: "18px",
        //fontFamily: "\"Arial\", \"Helvetica\", sans-serif",
        lineHeight: "18px",
        fontWeight: "bold" as "bold",
        //textTransform: "lowercase" as "lowercase",
        padding: "14px",
        height: "70px",
        backgroundColor: tabStyle.colorMain,
        "&:hover": {
          background: tabStyle.colorHover, //"#007000",
          color: tabStyle.colorText,
        }
      },
      inputChosen: {
        fontSize: "18px",
        //fontFamily: "\"Arial\", \"Helvetica\", sans-serif",
        lineHeight: "18px",
        fontWeight: "bold" as "bold",
        //textTransform: "lowercase" as "lowercase",
        padding: "14px",
        height: "70px",
        backgroundColor: tabStyle.colorHover, //"#56d242",
        "&:hover": {
          background: tabStyle.colorHover, //"#007000",
          color: tabStyle.colorText,
        }
      },
      inputAlt: {
        color: tabStyle.colorTextAlt,
      },
      inputText: {
        color: tabStyle.colorText
      },
      border: {
        borderStyle: "solid",
        borderWidth: "1px",
        //borderColor: theme.palette.primary.main,
        ///borderColor: "lightgrey",
        borderColor: "lavender",
        borderRadius: "0px",
        //boxShadow: "2px 2px 3px 2px #e6e6e6",
        //boxShadow: "0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)",
        //borderRadius: "4px",
        "&:hover": {
          //borderRadius: "4px",
          borderStyle: "solid",
          borderWidth: "1px",
          borderRadius: "0px",
          borderColor: "lavender",
        },
      },
      div: {
        //width: "100%",
        display: "flex",
        padding: "8px 44px"
      },
      fab: {
        //backgroundColor: "rgba(0,0,0,.5)",
        //backgroundColor: "white",
        color: "lightseagreen",
        //color: "rgba(0,0,0,.5)",
        position: 'absolute' as 'absolute',
        zIndex: 2,
        top: 'calc(50% - 18px)',
        width: 36,
        height: 36,
        cursor: 'pointer',
        "&:hover": {
          backgroundColor: "rgba(0,0,0,.15)",
        }
      },

});

const mapStateToProps = (state: AppState) => ({
  page: state.pageState,
});


export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(Zakladki))); 






